import React, { useState, useEffect } from "react";
import Question from "./components/Question";
import Answers from "./components/Answers";
import Share from "./components/Share";
import Progress from "./components/Progress";
import "./App.css";
import ReactGA from "react-ga";

function App() {
  const [showStartScreen, setShowStartScreen] = useState(true);
  const [showResults, setShowResults] = useState(false);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [currentAnswer, setCurrentAnswer] = useState("");
  const [score, setScore] = useState(0);

  const questions = [
    {
      id: 1,
      question: "Mihin ominaisuuteen summarivi liittyy?",
      img: "",
      answer_a: "Autosummaan",
      answer_b: "Taulukko-ominaisuuteen",
      answer_c: "Pivot-taulukkoon",
      answer_d: "En tiedä",
      correct_answer: "b",
    },
    {
      id: 2,
      question:
        "Miten saat kaikki alla olevat sarakkeet automaattisesti oikean levyisiksi (eli kaikki sisältö on näkyvillä kokonaan)?",
      img:
        "https://uploads-ssl.webflow.com/5c70197c6978d21cb08bfd76/5ead5616cd1146719e7169d2_quiz-sarakeleveys.png",
      answer_a: "Vetämällä sarakkeiden välistä",
      answer_b: "Tuplaklikkaamalla sarakkeen väliä",
      answer_c: "Maalaamalla sarakkeet ja tuplaklikkaamalla sarakkeen väliä",
      answer_d: "En tiedä",
      correct_answer: "c",
    },
    {
      id: 3,
      question:
        "Millä pikanäppäimillä saat valittua B3:F3 alueen sisällön mahdollisimman nopeasti kun B3 solu on aktiivisena (kuten kuvassa)? Eli haluat valita kaiken sisällön riviltä 3, mutta et koko riviä.",
      img:
        "https://uploads-ssl.webflow.com/5c70197c6978d21cb08bfd76/5ead55d4a0d3e4082e5f0ed3_quiz-aluevalinta.png",
      answer_a: "Ctrl + Shift + ->",
      answer_b: "Shift + ->",
      answer_c: "Shift + välilyönti",
      answer_d: "En tiedä",
      correct_answer: "a",
    },
    {
      id: 4,
      question:
        "Millä soluviittauksella saat kopioitua kaavan oikealle ja alas niin, että soluviittaus pysyy samassa sarakkeessa, mutta ei samalla rivillä?",
      img: "",
      answer_a: "$A$1",
      answer_b: "$A1",
      answer_c: "A$1",
      answer_d: "En tiedä",
      correct_answer: "b",
    },
    {
      id: 5,
      question:
        "Mikä on kuvassa olevan kaavan vastaus? (Sama kaava englanniksi: =COUNTIF($D$3:$D$9;D3)",
      img:
        "https://uploads-ssl.webflow.com/5c70197c6978d21cb08bfd76/5ead56076af9c86e02d81c23_quiz-laskejos.png",
      answer_a: "1",
      answer_b: "4",
      answer_c: "7",
      answer_d: "En tiedä",
      correct_answer: "b",
    },
    {
      id: 6,
      question:
        "Mihin kuvassa näkyvä ominaisuus 'osittaja' liittyy? (Englanniksi: slicer)",
      img:
        "https://uploads-ssl.webflow.com/5c70197c6978d21cb08bfd76/5eaf98d685c94f2915b63aa1_quiz-osittaja.png",
      answer_a: "Kaavioihin",
      answer_b: "Erikoissuodatukseen",
      answer_c: "Pivot-taulukkoon",
      answer_d: "En tiedä",
      correct_answer: "c",
    },
    {
      id: 7,
      question:
        "Miten kuvassa näkyvä kaavio lisätään? (Kaavio joka näkyy solussa numeroiden jälkeen)",
      img:
        "https://uploads-ssl.webflow.com/5c70197c6978d21cb08bfd76/5ead55f9ceae405686fb053c_quiz-kaavio.png",
      answer_a: "Lisää > Kaaviot > Viiva",
      answer_b: "Lisää > Sparkline-kaaviot > Viiva",
      answer_c: "Lisää > Kaaviot > Alue",
      answer_d: "En tiedä",
      correct_answer: "b",
    },
    {
      id: 8,
      question:
        "Mikä Excelin ominaisuus mahdollistaa kuvassa näkyvän kaavan? Eli miten kaavan ja/tai funktion sisällä voi olla 'vuokrat'",
      img:
        "https://uploads-ssl.webflow.com/5c70197c6978d21cb08bfd76/5ead56216c54eddfd092cae1_quiz-vuokrat.png",
      answer_a: "Nimetty alue",
      answer_b: "Taulukon sarake",
      answer_c: "Kustomoitu kaava",
      answer_d: "En tiedä",
      correct_answer: "a",
    },
    {
      id: 9,
      question: "Mikä on .xlsm-tiedostomuoto?",
      img: "",
      answer_a: "Vanha Excel-tiedosto (1997-2007)",
      answer_b: "Excel pohja",
      answer_c: "Makroja sisältävä Excel-tiedosto",
      answer_d: "En tiedä",
      correct_answer: "c",
    },
  ];

  const question = questions[currentQuestion];

  const start = () => {
    setShowStartScreen(false);
  };

  const handleClick = (e) => {
    setCurrentAnswer(e.target.value);
  };

  const next = () => {
    setCurrentAnswer("");

    if (currentAnswer === question.correct_answer) {
      setScore(score + 1);
    }

    if (currentQuestion + 1 < questions.length) {
      setCurrentQuestion(currentQuestion + 1);
      return;
    }

    setShowResults(true);
  };

  useEffect(() => {
    if (showResults) {
      // console.log(score);
      ReactGA.event({
        category: "Quiz",
        action: "Completed",
        label: score + " oikein",
      });
      window.dataLayer.push({ event: "optimize.activate" });
    }
  }, [showResults]);

  if (showStartScreen) {
    return (
      <div className="app center">
        <div>
          <h1>Excel osaamistesti</h1>
          <p className="paragraph-large">
            Testaa 2 minuutissa kuinka hyvin hallitset Excelin
            perusominaisuudet.
          </p>
          <img
            src="https://uploads-ssl.webflow.com/5c70197c6978d21cb08bfd76/5ea6c42b70b5054ac84bec86_testaa-excel-osaamisesi.png"
            className="img-quiz"
          ></img>
        </div>
        <button className="button" onClick={start}>
          Aloita osaamistesti
        </button>
      </div>
    );
  }

  if (showResults) {
    return (
      <div className="app">
        <Share score={score} totalQuestions={questions.length} />
      </div>
    );
  }

  return (
    <div className="content-medium">
      <Progress questionNumber={currentQuestion + 1} questions={questions} />
      <Question question={question.question} img={question.img} />
      <Answers
        question={question}
        currentAnswer={currentAnswer}
        handleClick={handleClick}
      />
      <button className="button" onClick={next}>
        {currentQuestion + 1 === questions.length
          ? "Katso tuloksesi"
          : "Seuraava kysymys"}
      </button>
    </div>
  );
}

ReactGA.initialize("UA-74343244-5");

export default App;
